<template>
	<div class="flex w-full justify-center p-4">
		<div class="relative w-full mt-8">
			<!-- Min Value -->
			<!-- <div
				:style="{ left: `${(min / max) * 100}%` }"
				class="absolute -translate-y-5 transform -translate-x-1/2 text-ihh-white bg-ihh-salmon text-[12px] font-thin rounded px-1 tracking-widest"
			>
				${{ min }}
				<div
					class="absolute bottom-0 transform translate-y-full w-0 h-0 border-l-3 border-r-3 border-t-3 border-t-ihh-salmon border-l-transparent border-r-transparent"
				></div>
			</div> -->
			<!-- Range Start -->
			<div
				:style="{ left: `${(range[0] / max) * 100}%` }"
				class="absolute -translate-y-5 transform -translate-x-1/2 text-ihh-white bg-ihh-salmon text-[12px] font-thin rounded px-1 tracking-widest"
			>
				${{ range[0] }}
			</div>
			<!-- Range End -->
			<div
				:style="{ left: `${(range[1] / max) * 100}%` }"
				class="absolute -translate-y-5 transform -translate-x-1/2 text-ihh-white bg-ihh-salmon text-[12px] font-thin rounded px-1 tracking-widest"
			>
				${{ range[1] }}
			</div>
			<!-- Max Value -->
			<!-- <div
				:style="{ left: `${(max / max) * 100}%` }"
				class="absolute -translate-y-5 transform -translate-x-1/2 text-gray-400 text-[12px] font-thin rounded px-1 tracking-widest"
			>
				${{ max }}
			</div> -->
			<!-- Vue Slider Component -->
			<VueSlider
				:min="min"
				:max="max"
				:interval="1"
				v-model="range"
				@change="$emit('update', range)"
				:tooltip="false"
				:dot-style="{
					'background-color': '#FFA4A4',
					'border-radius': '50%',
					width: '14px',
					height: '14px',
					border: '2px solid #fff',
				}"
				:process-style="{
					'background-color': '#FFA4A4',
					height: '6px',
				}"
				:track-style="{
					'background-color': '#E6E6E6',
					height: '6px',
				}"
				class="w-full custom-slider"
			/>
		</div>
	</div>
</template>

<script>
import { useModel } from '../../../helpers/model'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
	components: { VueSlider },
	props: ['modelValue'],
	setup(props, { emit }) {
		return {
			range: useModel(props, emit, 'modelValue'),
		}
	},
	data() {
		return {
			min: 0,
			max: 1000,
		}
	},
}
</script>

<style scoped>
.custom-slider .vue-slider-dot-hover,
.custom-slider .vue-slider-dot-active {
	background-color: #ff6b6b !important;
	border-color: #ff6b6b !important;
}
</style>
